// Mirrors Oracle's ScheduleDescription function (SCHEDULEDESCRIPTION, oid 1439) - dayNo is
// 1=Sunday...7=Saturday for Weekly, 1-31 or 99 (Last Day of Month) for Monthly.
const WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const scheduleDescription = (frequency?: string, dayNo?: number): string => {
    if (frequency === 'D') {
        return 'Daily';
    }
    if (frequency === 'W') {
        const dayName = dayNo && dayNo >= 1 && dayNo <= 7 ? WEEKDAY_NAMES[dayNo - 1] : '';
        return `Weekly on ${dayName}`;
    }
    if (frequency === 'M') {
        return dayNo === 99 ? 'Monthly on Last Day of Month' : `Monthly on ${dayNo ?? ''} Day of the Month`;
    }
    return '';
};

export default scheduleDescription;



// WEBPACK FOOTER //
// ./src/components/project-billing/components/scheduleDescription.ts